import {
  Module,
  VuexModule,
  Mutation,
  Action,
  getModule
} from "vuex-module-decorators";
import { auth, UserInfo } from "firebase";
import store from "@/store";

@Module({
  namespaced: true,
  name: "auth",
  dynamic: true,
  store
})
class AuthModule extends VuexModule {
  user: UserInfo | null = null;

  @Mutation
  setUser(user: UserInfo | null) {
    this.user = user;
  }

  @Action({ commit: "setUser" })
  getAuthenticatedUser() {
    return auth().currentUser;
  }

  @Action({ commit: "setUser" })
  async logout() {
    await auth().signOut();
    return null;
  }

  @Action 
  loginWithFacebook() {
    const provider = new auth.FacebookAuthProvider();
    return auth().signInWithRedirect(provider);
  }

  @Action
  loginWithGoogle() {
    const provider = new auth.GoogleAuthProvider();
    return auth().signInWithRedirect(provider);
  }

  @Action
  bindAuthentication() {
    return new Promise((resolve, reject) => {
      const unsubscribe = auth().onAuthStateChanged(user => {
          unsubscribe();
          console.log('Set user in bind auth ' + user);
          this.context.commit('setUser', user);
          resolve(user);
      }, reject);
    })
  }

  get isAuthenticated() {
    return this.user != null;
  }
}
const authModule = getModule(AuthModule);
export default authModule;
